import BadgeView from "./BadgeView";

export default BadgeView;
